'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$41(outer) {
  this.aZp = null;
  this.aZn = null;
  this.aZo = false;
  this.aZl = null;
  this.aZm = false;
  this.aZq = false;
  this.aZr = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aZp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_GroupsView$$anon$41 as $c_Lpresto_GroupsView$$anon$41 };
$p = $c_Lpresto_GroupsView$$anon$41.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$41;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$41() {
}
export { $h_Lpresto_GroupsView$$anon$41 as $h_Lpresto_GroupsView$$anon$41 };
$h_Lpresto_GroupsView$$anon$41.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aZp;
});
$p.t = (function() {
  if ((!this.aZo)) {
    this.aZn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aZo = true;
  }
  return this.aZn;
});
$p.ag = (function() {
  if ((!this.aZm)) {
    this.aZl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().k3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aZm = true;
  }
  return this.aZl;
});
$p.v = (function() {
  if ((!this.aZr)) {
    this.aZq = false;
    this.aZr = true;
  }
  return this.aZq;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_GroupsView$$anon$41 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$41, "presto.GroupsView$$anon$41", ({
  K4: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$41 as $d_Lpresto_GroupsView$$anon$41 };
//# sourceMappingURL=presto.-Groups-View$$anon$41.js.map
